<template>
    <accordion-section title="Inventory" @toggle="updateOpen">
        <b-table :data="product.children" striped bordered>
            <b-table-column v-for="column in columns" :key="column.field" :id="column.field" :label="column.label" :centered="column.centered" v-slot="props">
                {{ column.field === "stock.quantity" ? getStock(props.row, product.retailers) : props.row[column.field] }}
            </b-table-column>
            <b-table-column id="actions" label="Actions" centered v-slot="props" width="30%">
                <b-button v-for="retailer in product.retailers"  :key="`retailer-button-${retailer.id}`" tag="button" size="is-small" type="is-primary" :label="`View History: ${retailer.name}`"
                          @click.prevent="assignProduct(props.row, retailer)" class="mb-0 mr-1">
                </b-button>
            </b-table-column>
        </b-table>
        <product-stock-history :accordion-state="open" v-if="product_id" :product_id="product_id" :retailer_id="retailer_id"></product-stock-history>
    </accordion-section>
</template>

<script>
    import _ from "lodash";

    export default {
        props: {
            product: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                open: false,
                product_id: false,
                retailer_id: false,
                columns: [
                    {
                        field: 'sku',
                        label: 'Sku'
                    },
                    {
                        label: 'Size',
                        field: 'size',
                        numeric: true
                    },
                    {
                        field: 'stock.quantity',
                        label: 'Quantity',
                        numeric: true
                    }
                ]
            }
        },
        methods: {
            updateOpen(state) {
                this.open = state;
            },
            assignProduct(item, retailer) {
                this.product_id = item.id;
                this.retailer_id = retailer.id
            },
            getStock(children, retailers) {
                let stocks = [];
                for (let stock of children.stock) {
                    let retailer = _.find(retailers, {id: stock.retailer_id})
                    stocks.push(`${retailer.name}: ${stock.quantity}`)
                }
                return stocks.join(',');
            }
        }
    }
</script>
